import { gql } from "@apollo/client";

export const DELETE_WAREHOUSE_LOCATION_INFO_BY_ID = gql`
    mutation DeleteWarehouseLocationInfoById($request: WarehouseLocationInfoDeleteRequestInput!) {
        deleteWarehouseLocationInfoById(request: $request)
    }
`;

export interface WarehouseLocationInfoDeleteRequestInput {
    locationId: number;
}

export interface DeleteWarehouseLocationInfoByIdResponse {
    deleteWarehouseLocationInfoById: boolean;
}

